(function () {
  'use strict';

  var initializedSections = new WeakMap();
  var assignmentCache = {};
  var assignmentAnalyticsPublished = {};

  function parseJsonScript(script, warningMessage) {
    if (!script) {
      return null;
    }

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.warn('[product-ab-test]', warningMessage, error);
      return null;
    }
  }

  function sanitizeCookiePart(value) {
    return String(value || '')
      .trim()
      .replace(/[^a-zA-Z0-9_-]/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function normalizeTestConfig(config) {
    if (!config) {
      return null;
    }

    var products = Array.isArray(config.products) ? config.products.filter(Boolean) : [];
    if (products.length < 2) {
      return null;
    }

    var normalized = {};
    Object.keys(config).forEach(function (key) {
      normalized[key] = config[key];
    });

    normalized.products = products;
    normalized.testId = normalized.testId || (products[0] && products[0].handle);
    normalized.cookieName = normalized.cookieName || ('elanora_ab_' + sanitizeCookiePart(normalized.testId));
    normalized.cookieDays = normalized.cookieDays || 30;
    normalized.canonicalProductHandle = normalized.canonicalProductHandle || (products[0] && products[0].handle);
    normalized.canonicalPath = normalized.canonicalPath || (products[0] && products[0].path);

    return normalized;
  }

  function getGlobalTests() {
    var globalConfig = parseJsonScript(
      document.querySelector('[data-ab-tests-config]'),
      'Invalid global config JSON'
    );
    var tests = globalConfig && Array.isArray(globalConfig.tests) ? globalConfig.tests : [];

    return tests
      .map(normalizeTestConfig)
      .filter(Boolean);
  }

  function parseLegacySectionConfig(section) {
    return normalizeTestConfig(parseJsonScript(
      section.querySelector('[data-ab-test-config]'),
      'Invalid section config JSON'
    ));
  }

  function getCookie(name) {
    var prefix = name + '=';
    var parts = document.cookie ? document.cookie.split('; ') : [];

    for (var i = 0; i < parts.length; i += 1) {
      if (parts[i].indexOf(prefix) === 0) {
        return decodeURIComponent(parts[i].slice(prefix.length));
      }
    }

    return '';
  }

  function setCookie(name, value, days) {
    var expires = '';
    var duration = parseInt(days, 10);

    if (duration > 0) {
      var date = new Date();
      date.setTime(date.getTime() + duration * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }

    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  function chooseVariant(config) {
    var cookieName = config.cookieName || ('elanora_ab_' + sanitizeCookiePart(config.testId));
    var savedVariant = getCookie(cookieName);
    var products = Array.isArray(config.products) ? config.products : [];
    var existing = products.find(function (item) {
      return item && item.variant === savedVariant;
    });

    if (existing) {
      return existing;
    }

    var assignedIndex = Math.floor(Math.random() * products.length);
    var assigned = products[assignedIndex] || products[0];

    if (assigned && assigned.variant) {
      setCookie(cookieName, assigned.variant, config.cookieDays || 30);
    }

    return assigned;
  }

  function getAssignment(config) {
    var key = config.cookieName || config.testId;
    if (!assignmentCache[key]) {
      assignmentCache[key] = chooseVariant(config);
    }

    return assignmentCache[key];
  }

  function buildPayload(config, assignment, eventName) {
    return {
      event: eventName,
      ab_test_id: config.testId,
      ab_variant: assignment.variant,
      ab_product_handle: assignment.handle,
      canonical_product_handle: config.canonicalProductHandle,
      canonical_path: config.canonicalPath
    };
  }

  function getShopifyCustomerEventName(eventName) {
    var eventNames = {
      product_ab_test_assigned: 'elanora:ab_test_assigned',
      product_ab_test_offer_view: 'elanora:ab_test_offer_viewed',
      product_ab_test_add_to_cart: 'elanora:ab_test_add_to_cart'
    };

    return eventNames[eventName] || ('elanora:' + eventName);
  }

  function publishShopifyCustomerEvent(config, assignment, eventName, payload) {
    var shopifyEventName = getShopifyCustomerEventName(eventName);

    if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') {
      return;
    }

    try {
      window.Shopify.analytics.publish(shopifyEventName, {
        source_event: eventName,
        ab_test_id: config.testId,
        ab_variant: assignment.variant,
        ab_product_handle: assignment.handle,
        canonical_product_handle: config.canonicalProductHandle,
        canonical_path: config.canonicalPath,
        data_layer_payload: payload
      });
    } catch (error) {
      console.warn('[product-ab-test]', 'Unable to publish Shopify customer event', error);
    }
  }

  function pushAnalytics(config, assignment, eventName) {
    var payload = buildPayload(config, assignment, eventName);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    publishShopifyCustomerEvent(config, assignment, eventName, payload);

    if (typeof window.gtag === 'function') {
      window.gtag('set', 'user_properties', {
        product_ab_test_id: config.testId,
        product_ab_variant: assignment.variant,
        product_ab_product_handle: assignment.handle
      });
    }
  }

  function publishAssignmentOnce(config, assignment) {
    var key = config.cookieName || config.testId;
    if (assignmentAnalyticsPublished[key]) {
      return;
    }

    assignmentAnalyticsPublished[key] = true;
    pushAnalytics(config, assignment, 'product_ab_test_assigned');
  }

  function productBelongsToTest(config, handle) {
    return Array.isArray(config.products) && config.products.some(function (item) {
      return item && item.handle === handle;
    });
  }

  function findFirstTestForProduct(tests, handle) {
    if (!handle) {
      return null;
    }

    for (var i = 0; i < tests.length; i += 1) {
      if (productBelongsToTest(tests[i], handle)) {
        return tests[i];
      }
    }

    return null;
  }

  function cloneConfig(config) {
    var cloned = {};
    Object.keys(config).forEach(function (key) {
      cloned[key] = config[key];
    });
    return cloned;
  }

  function getSectionConfig(section, tests) {
    var legacyConfig = parseLegacySectionConfig(section);
    var currentProductHandle;
    var config;

    if (legacyConfig) {
      config = cloneConfig(legacyConfig);
    } else {
      currentProductHandle = section.dataset.abCurrentProductHandle || section.dataset.currentProductHandle || '';
      config = tests.find(function (test) {
        return test.testId === section.dataset.abTestId && productBelongsToTest(test, currentProductHandle);
      }) || findFirstTestForProduct(tests, currentProductHandle);

      if (!config) {
        return null;
      }

      config = cloneConfig(config);
    }

    config.sectionId = section.dataset.section || config.sectionId;
    config.currentProductHandle = section.dataset.abCurrentProductHandle ||
      section.dataset.currentProductHandle ||
      config.currentProductHandle;
    config.canonicalProductHandle = section.dataset.canonicalProductHandle ||
      config.canonicalProductHandle;
    config.canonicalPath = section.dataset.canonicalPath ||
      config.canonicalPath;

    return config;
  }

  function replaceProductLinks(root, config) {
    var products = Array.isArray(config.products) ? config.products : [];
    var paths = products
      .map(function (item) { return item && item.path; })
      .filter(Boolean);

    root.querySelectorAll('a[href]').forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href) return;

      var shouldProtect = link.hasAttribute('data-ab-protected-link') ||
        paths.some(function (path) {
          return href === path || href.indexOf(path + '?') === 0 || href.indexOf(path + '#') === 0;
        });

      if (shouldProtect) {
        link.setAttribute('href', config.canonicalPath);
        link.setAttribute('data-ab-protected-link', '');
      }
    });
  }

  function updateCardLinks(card, config) {
    if (!config.canonicalPath) {
      return;
    }

    card.querySelectorAll('a[href]').forEach(function (link) {
      link.setAttribute('href', config.canonicalPath);
      link.setAttribute('data-ab-protected-link', '');
    });

    card.querySelectorAll('[data-product-url]').forEach(function (element) {
      element.setAttribute('data-product-url', config.canonicalPath);
    });
  }

  function upsertHiddenInput(form, name, value) {
    var selector = 'input[type="hidden"][name="' + name.replace(/"/g, '\\"') + '"]';
    var input = form.querySelector(selector);

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }

    input.value = value || '';
    input.setAttribute('data-ab-test-property', '');
  }

  function getPropertyFields(config, assignment) {
    return [
      { fieldName: '_ab_test_id', value: config.testId },
      { fieldName: '_ab_variant', value: assignment.variant },
      { fieldName: '_ab_product_handle', value: assignment.handle },
      { fieldName: '_ab_canonical_path', value: config.canonicalPath }
    ];
  }

  function annotateForms(root, config, assignment) {
    var fields = getPropertyFields(config, assignment);

    root.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      fields.forEach(function (field) {
        upsertHiddenInput(form, 'properties[' + field.fieldName + ']', field.value);
      });
    });
  }

  function decorateProductForms(root, config, assignment) {
    root.querySelectorAll('product-form').forEach(function (productForm) {
      var fields = getPropertyFields(config, assignment);
      var existingFields = Array.prototype.slice.call(productForm.customFields || []);
      var nonAbFields = existingFields.filter(function (field) {
        return !field || !field.fieldName || field.fieldName.indexOf('_ab_') !== 0;
      });

      productForm.customFields = nonAbFields.concat(fields);
    });
  }

  function bindFormAnalytics(root, config, assignment) {
    root.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (form.dataset.abAnalyticsBound === 'true') return;

      form.dataset.abAnalyticsBound = 'true';
      form.addEventListener('submit', function () {
        annotateForms(root, config, assignment);
        decorateProductForms(root, config, assignment);
        pushAnalytics(config, assignment, 'product_ab_test_add_to_cart');
      }, true);
    });
  }

  function updateFormProductTargets(root, offerTemplate) {
    var variantId = offerTemplate && offerTemplate.dataset.variantId;
    var productId = offerTemplate && offerTemplate.dataset.productId;

    if (!variantId && !productId) {
      return;
    }

    root.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var variantInput = form.querySelector('input[name="id"]');
      var productIdInput = form.querySelector('input[name="product-id"]');

      if (variantInput && variantId) {
        variantInput.value = variantId;
        variantInput.dataset.value = variantId;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (productIdInput && productId) {
        productIdInput.value = productId;
      }
      if (form.dataset.productId && productId) {
        form.dataset.productId = productId;
      }
    });
  }

  function prepareAssignedSection(section, config, assignment) {
    var productInfo = section.querySelector('#ProductInfo-' + config.sectionId);

    if (productInfo && config.canonicalPath) {
      productInfo.dataset.url = config.canonicalPath;
    }

    section.setAttribute('data-ab-active-variant', assignment.variant);
    section.setAttribute('data-ab-active-product-handle', assignment.handle);
    replaceProductLinks(section, config);
    annotateForms(section, config, assignment);
    decorateProductForms(section, config, assignment);
    bindFormAnalytics(section, config, assignment);
    pushAnalytics(config, assignment, 'product_ab_test_offer_view');
  }

  function findOfferTemplate(section, assignment) {
    var selector = 'template[data-ab-offer-template="' +
      String(assignment.handle || '').replace(/"/g, '\\"') + '"]';
    return section.querySelector(selector);
  }

  function findCardOfferTemplate(card, assignment) {
    var selector = 'template[data-ab-card-offer-template="' +
      String(assignment.handle || '').replace(/"/g, '\\"') + '"]';
    return card.querySelector(selector);
  }

  function getTemplateRoot(template) {
    return template && template.content ? template.content : template;
  }

  function replaceInnerMarkup(current, offered) {
    if (current && offered) {
      current.innerHTML = offered.innerHTML;
    }
  }

  function replaceElement(current, offered) {
    if (current && offered) {
      current.replaceWith(offered.cloneNode(true));
    }
  }

  function updateOfferForms(section, config, offerTemplate) {
    var variantId = offerTemplate.dataset.variantId;
    var productId = offerTemplate.dataset.productId;
    var formSelectors = [
      '#product-form-' + config.sectionId,
      '#product-form-installment-' + config.sectionId
    ];

    formSelectors.forEach(function (selector) {
      var form = section.querySelector(selector);
      if (!form) return;

      var variantInput = form.querySelector('input[name="id"]');
      var productIdInput = form.querySelector('input[name="product-id"]');

      if (variantInput && variantId) {
        var variantChanged = variantInput.value !== variantId;
        variantInput.value = variantId;
        if (variantChanged) {
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      if (productIdInput && productId) {
        productIdInput.value = productId;
      }
      if (form.dataset.productId && productId) {
        form.dataset.productId = productId;
      }
    });
  }

  function updateProductTargets(section, config, offerTemplate) {
    var productInfo = section.querySelector('#ProductInfo-' + config.sectionId);
    var pickupAvailability = section.querySelector('pickup-availability');
    var addButton = section.querySelector('#ProductSubmitButton-' + config.sectionId);
    var stickyAtc = section.querySelector('#sticky-atc-' + config.sectionId);
    var stickyButton = section.querySelector('#StickyAtcSubmitButton-' + config.sectionId);
    var isAvailable = offerTemplate.dataset.available === 'true';
    var hasPickupAvailability = offerTemplate.dataset.pickupAvailable === 'true';

    if (productInfo && config.canonicalPath) {
      productInfo.dataset.url = config.canonicalPath;
    }
    if (pickupAvailability && offerTemplate.dataset.variantId) {
      pickupAvailability.dataset.variantId = offerTemplate.dataset.variantId;
      pickupAvailability.dataset.hasOnlyDefaultVariant = offerTemplate.dataset.hasOnlyDefaultVariant;

      if (hasPickupAvailability && typeof pickupAvailability.fetchAvailability === 'function') {
        if (!pickupAvailability.errorHtml) {
          var pickupTemplate = pickupAvailability.querySelector('template');
          if (pickupTemplate && pickupTemplate.content.firstElementChild) {
            pickupAvailability.errorHtml = pickupTemplate.content.firstElementChild.cloneNode(true);
            pickupAvailability.onClickRefreshList = pickupAvailability.onClickRefreshList.bind(pickupAvailability);
          }
        }
        pickupAvailability.setAttribute('available', '');
        pickupAvailability.fetchAvailability(offerTemplate.dataset.variantId);
      } else {
        pickupAvailability.removeAttribute('available');
        pickupAvailability.innerHTML = '';
        var pickupDrawer = document.querySelector('pickup-availability-drawer');
        if (pickupDrawer) {
          pickupDrawer.remove();
        }
      }
    }
    if (addButton) {
      addButton.disabled = !isAvailable;
    }
    if (stickyButton) {
      stickyButton.disabled = !isAvailable;
    }
    if (stickyAtc) {
      stickyAtc.hidden = !isAvailable;
      stickyAtc.setAttribute('aria-hidden', isAvailable ? 'false' : 'true');
      stickyAtc.style.display = isAvailable ? '' : 'none';
    }
  }

  function updateQuantityBreaks(section, config, offerContent) {
    var current = section.querySelector('#quantity-breaks-' + config.sectionId);
    var offered = offerContent.querySelector('[data-ab-quantity-breaks] quantity-breaks');
    if (!current || !offered) return;

    var updated = offered.cloneNode(true);
    current.replaceWith(updated);

    var productFormElement = section.querySelector('#product-form-' + config.sectionId);
    var productForm = productFormElement && productFormElement.closest('product-form');
    if (productForm) {
      productForm.quantityBreaks = updated;
    }
  }

  function activateOffer(section, config, assignment) {
    var offerTemplate = findOfferTemplate(section, assignment);

    if (!offerTemplate) {
      console.warn('[product-ab-test]', 'Falling back to current product offer: missing embedded offer', assignment.handle);
      prepareAssignedSection(section, config, assignment);
      return;
    }

    var offerContent = offerTemplate.content.cloneNode(true);
    var price = section.querySelector('#price-' + config.sectionId + ' .product-info-price-wrapper .price');
    var offeredPrice = offerContent.querySelector('[data-ab-main-price] .price');
    var stickyPrice = section.querySelector('#atc-price-' + config.sectionId);
    var offeredStickyPrice = offerContent.querySelector('[data-ab-sticky-price]');

    replaceElement(price, offeredPrice);
    replaceInnerMarkup(stickyPrice, offeredStickyPrice);
    updateQuantityBreaks(section, config, offerContent);
    updateOfferForms(section, config, offerTemplate);
    updateProductTargets(section, config, offerTemplate);
    prepareAssignedSection(section, config, assignment);
    section.dispatchEvent(new CustomEvent('elanora:ab-offer-activated', { bubbles: true }));
  }

  function applyCardOffer(card, config, assignment) {
    var offerTemplate = findCardOfferTemplate(card, assignment);
    var offerContent = getTemplateRoot(offerTemplate);
    var offeredPrice = offerContent && offerContent.querySelector('[data-ab-card-offer-price]');
    var offeredBadge = offerContent && offerContent.querySelector('[data-ab-card-offer-badge]');
    var priceTarget = card.querySelector('[data-ab-card-price]');
    var badgeTargets = card.querySelectorAll('[data-ab-card-badge]');

    if (priceTarget && offeredPrice) {
      priceTarget.innerHTML = offeredPrice.innerHTML;
    }

    badgeTargets.forEach(function (badgeTarget) {
      badgeTarget.innerHTML = offeredBadge ? offeredBadge.innerHTML : '';
    });

    card.setAttribute('data-ab-active-variant', assignment.variant);
    card.setAttribute('data-ab-active-product-handle', assignment.handle);
    updateCardLinks(card, config);

    if (offerTemplate) {
      updateFormProductTargets(card, offerTemplate);
    }

    annotateForms(card, config, assignment);
    decorateProductForms(card, config, assignment);
    bindFormAnalytics(card, config, assignment);
  }

  function selectAll(root, selector) {
    var items = [];

    if (root && typeof root.matches === 'function' && root.matches(selector)) {
      items.push(root);
    }

    if (root && typeof root.querySelectorAll === 'function') {
      items = items.concat(Array.prototype.slice.call(root.querySelectorAll(selector)));
    }

    return items;
  }

  function initSection(section, tests) {
    if (!section) {
      return;
    }

    var config = getSectionConfig(section, tests);
    if (!config) {
      return;
    }

    var sectionKey = [config.testId, config.currentProductHandle, config.sectionId].join('|');
    if (initializedSections.get(section) === sectionKey) {
      return;
    }
    initializedSections.set(section, sectionKey);

    var assignment = getAssignment(config);
    if (!assignment) {
      return;
    }

    publishAssignmentOnce(config, assignment);

    if (assignment.handle === config.currentProductHandle) {
      prepareAssignedSection(section, config, assignment);
      return;
    }

    activateOffer(section, config, assignment);
  }

  function initCards(root, tests) {
    selectAll(root || document, '[data-ab-product-card]').forEach(function (card) {
      var productHandle = card.dataset.abProductHandle || card.dataset.productHandle;
      var config = card.dataset.abTestId ?
        tests.find(function (test) {
          return test.testId === card.dataset.abTestId && productBelongsToTest(test, productHandle);
        }) :
        findFirstTestForProduct(tests, productHandle);

      if (!config) {
        return;
      }

      var assignment = getAssignment(config);
      if (!assignment) {
        return;
      }

      publishAssignmentOnce(config, assignment);
      applyCardOffer(card, config, assignment);
    });
  }

  function init(root) {
    var tests = getGlobalTests();
    var target = root || document;

    selectAll(target, '[data-ab-test-section]').forEach(function (section) {
      initSection(section, tests);
    });
    initCards(target, tests);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('elanora:ab-content-updated', function (event) {
    init((event.detail && event.detail.root) || document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();
